import { Dispatch, SetStateAction, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Button, InputBase, Stack } from '@mui/material';
import { useField } from 'formik';

export type OptionTypes = {
    value: string;
    label: string;
};

type CounterInputProps = {
    label: string;
    placeholder?: string;
    name: string;
    setFieldValue: any;
    boxStyling?: object;
    setParentState?: Dispatch<SetStateAction<number>>;
    disabled?: boolean;
};

export const CounterInput: React.FC<CounterInputProps> = ({
    label,
    placeholder,
    name,
    setFieldValue,
    boxStyling,
    disabled,
    setParentState,
    ...props
}) => {
    const [field, meta] = useField(name);
    const [count, setCount] = useState(field.value);

    // Increment the count value by +1
    const increment = () => {
        setFieldValue(name, count + 1);
        setCount((prevCount) => Number(prevCount) + 1);
        setParentState && setParentState((prevState) => Number(prevState) + 1);
    };

    // Decrement the count value by -1
    const decrement = () => {
        if (count === 0) {
            return;
        }
        setFieldValue(name, count - 1);
        setCount((prevCount) => Number(prevCount) - 1);
        setParentState && setParentState((prevState) => Number(prevState) - 1);
    };

    return (
        <Stack sx={{ position: 'relative' }}>
            <label className="mb-5 font-bold">{label}</label>
            <Box className={`counter-input-base`} {...boxStyling}>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor={meta.touched && meta.error ? '#f06c62' : '#F3A256'}
                    height="32px"
                    width="32px"
                    borderRadius="4px"
                    color="white"
                    fontSize="32px"
                >
                    <Button
                        sx={{
                            width: '32px',
                            height: '100%',
                            padding: 0,
                            color: 'white',
                            fontSize: '32px',
                        }}
                        onClick={decrement}
                        disabled={disabled}
                    >
                        <RemoveIcon />
                    </Button>
                </Box>

                <InputBase
                    {...field}
                    {...props}
                    value={count}
                    onChange={(e) => {
                        setCount(Number(e.target.value));
                        setParentState && setParentState(Number(e.target.value));
                        setFieldValue(name, Number(e.target.value));
                    }}
                    placeholder={placeholder}
                    autoComplete="off"
                    sx={{
                        height: '100%',
                        '&.MuiInputBase-root input': {
                            textAlign: 'center',
                            borderBottom:
                                meta.touched && meta.error
                                    ? '1px solid #f06c62'
                                    : '1px solid #F18F34',
                            width: '100px',
                            height: '56px',
                        },
                    }}
                    disabled={disabled}
                />
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="32px"
                    width="32px"
                    borderRadius="4px"
                    color="white"
                    fontSize="32px"
                    bgcolor={meta.touched && meta.error ? '#f06c62' : '#F3A256'}
                >
                    <Button
                        sx={{
                            width: '32px',
                            height: '100%',
                            padding: 0,
                            color: 'white',
                            fontSize: '32px',
                        }}
                        onClick={increment}
                        disabled={disabled}
                    >
                        <AddIcon />
                    </Button>
                </Box>
            </Box>
            {meta.touched && meta.error && (
                <label className="input-base-field-error">{meta.error}</label>
            )}
        </Stack>
    );
};
